module.exports = __webpack_public_path__ + "static/vr-icon-123c396b10bdebc6065e3c21aa684a78.png";